import ActivityLog from "./ActivityLog";
import ChangeCamera from "./ChangeCamera";
import DeleteActivityLogEvent from "./DeleteActivityLogEvent";
import Empty from "./Empty";
import GetSignedUrl from "./GetSignedUrl";
import Ping from "./Ping";
import PlayCommand from "./PlayCommand";
import PlayLullaby from "./PlayLullaby";
import StartMonitoring from "./StartMonitoring";
import StartVideoBroadcasting from "./StartVideoBroadcasting";
import StartVideoReceiving from "./StartVideoReceiving";
import StartVideoRecording from "./StartVideoRecording";
import StopVideoRecording from "./StopVideoRecording";
import StopMonitoring from "./StopMonitoring";
import SyncFromBS from "./SyncFromBS";
import TakeVideoSnapshot from "./TakeVideoSnapshot";

export { default as RPCResponse } from "./RPCResponse";

export const RPCResponses = {
  ActivityLog,
  ChangeCamera,
  DeleteActivityLogEvent,
  Empty,
  GetSignedUrl,
  Ping,
  PlayCommand,
  PlayLullaby,
  StartMonitoring,
  StartVideoBroadcasting,
  StartVideoReceiving,
  StartVideoRecording,
  StopVideoRecording,
  StopMonitoring,
  SyncFromBS,
  TakeVideoSnapshot
};
